import { IS_CLIENT_SIDE } from '@/core/settings/constants';

type AppleMobileDevice = 'iPad' | 'iPhone';

export const isAppleMobileDevice = (): boolean => {
  const deviceTypes: AppleMobileDevice[] = ['iPad', 'iPhone'];
  if (IS_CLIENT_SIDE) {
    for (let i = 0; i < deviceTypes.length; i++) {
      if (navigator?.userAgent.includes(deviceTypes[i])) {
        return true;
      }
    }
  }
  return false;
};
